<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :for_id="save_to"/>
      <div class="multiplefiles-container" v-for="(file, index) in files" :key="index">
        <div class="upload-btn-container" v-if="!(typeof file === 'string' || file instanceof String)">
          <input
            :id="`${save_to}_${index}`"
            type="file"
            :name="`${validationLabel || label}_${index}`"
            :key="`${save_to}_${index}`"
            :ref="`${save_to}_${index}`"
            v-on:change="handleFileUpload(index)"
            :required="required && index == httpFiles.length"
            :class="{'has-error': errors.has(validationLabel || label)}"
            :accept="accept"
          />
        </div>
        <div class="existing-multiplefiles" v-else>
          <span class="delete-multiplefiles" @click="deleteLink(index)">
            <svg viewBox="0 0 448 512">
              <path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"/>
            </svg>
          </span>
          <span class="link-multiplefiles"><a :href="file">{{ file.split('/').slice(-1)[0] }}</a></span>
        </div>
        <span class="error" v-show="errors.has(validationLabel || label)">{{ errors.first(validationLabel || label) }}</span>
      </div>
      <div class="button_wrapper">
        <button type="button" @click.prevent="addFile()">Ajouter un fichier</button>
        <button type="button button-retirer-ligne" @click.prevent="removeFile()" v-if="files.length > 1 && files.length - httpFiles.length > 0">Retirer un fichier</button>
      </div>
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';

export default {
  name: 'MultipleFiles',
  mixins: [validatorComponent],
  props: {
    save_to: String,
    type: String,
    isButtonUpload: Boolean,
    buttonUploadLabel: String,
    validationLabel: String,
    sizeMax: {
      type: Number,
      default: 2560
    },
    accept: {
      type: String,
      //required: true
    },
    required: Boolean,
    validationRules: [String, Object],
    autocomplete: String,
    inputmode: {
      type: String,
      default: 'text'
    },
    pattern: String
  },
  data: function() {
    return {
      files: [{
        data: undefined,
      }]
    }
  },
  computed: {
    rules () {
      if(this.require) {
        return 'required|size:' + this.sizeMax;
      }
      return 'size:' + this.sizeMax;
    },
    httpFiles() {
      return this.files.filter((file)=>(typeof file === 'string' || file instanceof String))
    }
  },
  watch: {
    files: {
      deep: true,
      handler() {
        this.$emit('input', this.files.map((file)=> {
          if(file.data) {
            return file.data
          } else {
            return file;
          }
        }));
      }
    }
  },
  created() {
    const existingFiles = (this.val || []);
    if(existingFiles.length) {
      this.files = [...existingFiles]
    }
  },
  methods: {
    addFile() {
      this.files.push({data: undefined})
    },
    removeFile() {
      const lastFile = this.files[this.files.length-1];
      if(lastFile && !(typeof lastFile === 'string' || lastFile instanceof String)) {
        this.files.pop()
      }
    },
    deleteLink(index) {
      this.files.splice(index, 1);
    },
    handleFileUpload (index) {
      const file = this.$refs[`${this.save_to}_${index}`][0].files[0];
      if (file !== 'undefined') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
          this.files[index].data = reader.result;
        };
      }
    }
  }
};
</script>
<style>
.delete-multiplefiles {
  cursor: pointer;
}
.delete-multiplefiles svg {
  width: 20px;
  cursor: pointer;
}
</style>